import { Link } from "react-router-dom";
import { CloudUpload } from "lucide-react";
import { useAuth } from "@/context/Auth";

export const GuestSaveBanner = ({ testid = "guest-save-banner" }) => {
  const { user } = useAuth();
  if (user !== false) return null;
  return (
    <div data-testid={testid} className="card px-5 py-4 flex flex-wrap items-center gap-3 justify-between" style={{ borderStyle: "dashed" }}>
      <p className="text-sm flex items-center gap-2" style={{ color: "var(--ink-2)" }}>
        <CloudUpload size={16} style={{ color: "var(--accent)" }} />
        Practising as a guest. Your attempts are saved on this device only. Create a free account to keep them across devices.
      </p>
      <div className="flex gap-2">
        <Link to="/account?register" data-testid={`${testid}-register`} className="btn-primary h-9 px-4 rounded-full text-sm font-semibold flex items-center">Create account</Link>
        <Link to="/account" data-testid={`${testid}-login`} className="btn-ghost h-9 px-4 rounded-full text-sm font-medium flex items-center">Sign in</Link>
      </div>
    </div>
  );
};
